<nz-form-item>
  <nz-form-label nzFor="category">Statut</nz-form-label>
  <nz-form-control [nzErrorTip]="error">
    <nz-select [formControl]="formControl" nzMode="default" nzPlaceHolder="Statut" [nzSize]="typeSize" class="w-100-p">
      <nz-option *ngFor="let value of values" [nzValue]="value" [nzLabel]="value | serviceStatusName | nullCoal"></nz-option>
    </nz-select>
  </nz-form-control>
  <ng-template #error let-control>
    <ng-container *ngIf="control?.hasError('required')">
      Le status est requis
    </ng-container>
  </ng-template>
</nz-form-item>
